export const SET_USER = 'SET_USER';
export const SET_ALERT_MESSAGE = "SET_ALERT_MESSAGE";
export const SET_ALERT_ERROR = "SET_ALERT_ERROR";
export const SET_LANG = "SET_LANG";
export const TOGGLE_MOBILE_VIDEO = "TOGGLE_MOBILE_VIDEO";

